import { StaticFieldIds } from './static-field-ids.enum';

export abstract class FormsRegisterStaticField {
  public readonly static = true;
  public abstract content: string;
  public abstract readonly id: StaticFieldIds;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public constructor({ form, template }) {}
}
